import { Component, EventEmitter, input, Input, Output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { EmptyStateComponent } from '../../../../shared/components/empty-state/empty-state.component';
import { DashboardGridsterItem } from '../../../../shared/constants/dashboard-settings';

@Component({
    selector: 'app-widget',
    templateUrl: 'widget.component.html',
    styleUrls: ['widget.component.scss'],
    imports: [
    TranslatePipe,
    ButtonComponent,
    NgTemplateOutlet,
    EmptyStateComponent
],
})
export class WidgetComponent {
    @Input() item: DashboardGridsterItem = {} as DashboardGridsterItem;
    @Input() widgetContentTemplate: TemplateRef<any> | null = null;
    @Input() widgetEmptyStateTemplate: TemplateRef<any> | null = null;
    @Input() severity: 'none' | 'success' | 'warning' | 'danger' = 'none';
    @Input() emptyState: boolean = false;
    @Input() prefix = 'enum.folderDashboardWidgets.';
    @Input() headerLabel: string | undefined = undefined; // must be translated due to some params and so on ...

    public canEdit = input<boolean>(true);
    public headerActionsTemplate = input<TemplateRef<unknown> | null>(null);

    @Output() added = new EventEmitter<void>();
    @Output() edit = new EventEmitter<void>();
    @Output() opened = new EventEmitter<void>();
}
